import React from "react";
import { Redirect, Link } from "react-router-dom";
import { Query } from "react-apollo";
import styled from "styled-components";

import Loading from "../components/Loading/Loading";
import Emoji from "../components/Emoji/Emoji";

import Header from "../components/Header/Header";
import ShareButtons from "../components/ShareButtons";
import Menu from "../components/Menu";

import partyByCodeQuery from "../queries/partyByCodeQuery.gql";
import { connect } from "react-redux";

const RowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const EmojiContainer = styled.div`
  font-size: 70px;
  margin-right: 15px;
  width: 150px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;
const TextContainer = styled.div`
  flex: 2;
`;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  position: relative;
  flex-grow: 2;
`;

const Inner = styled.div`
  max-width: 960px;
  margin: 100px auto;
`;

const OverviewPage = ({ code }) =>
  !code ? (
    <Redirect to={`/politicus`} />
  ) : (
    <PageWrapper>
      <Header />
      <Content>
        <Menu />
        <Inner>
          <h1>Je voorstellen zijn bewaard</h1>
          <Query query={partyByCodeQuery} variables={{ code }}>
            {({ loading, error, data }) => {
              if (loading) return <Loading />;
              if (error) return <Redirect to="/reset" />;

              return (
                <React.Fragment>
                  {data.party.emojis.map(row => (
                    <RowContainer key={`emoji-${row.id}`}>
                      <EmojiContainer>
                        <Emoji>{row.emoji}</Emoji>
                      </EmojiContainer>
                      <TextContainer>
                        <h2>{row.title}</h2>
                        <p>{row.body}</p>
                      </TextContainer>
                    </RowContainer>
                  ))}

                  <ShareButtons
                    mode="party"
                    party={data.party}
                    city={data.party.city}
                  />

                  <p>
                    Foutje gemaakt? <Link to={`/indienen`}>Pas aan.</Link>
                  </p>
                </React.Fragment>
              );
            }}
          </Query>
        </Inner>
      </Content>
    </PageWrapper>
  );

const mapStateToProps = state => {
  return {
    code: state.code
  };
};

export default connect(mapStateToProps)(OverviewPage);



// WEBPACK FOOTER //
// ./src/pages/Overview.js